import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

// This component can be added to any page to handle auth tokens
const AuthHandler = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const processAuthToken = async () => {
      // Check if the URL contains an access token
      if (location.hash && location.hash.includes('access_token')) {
        setIsProcessing(true);
        console.log("AuthHandler detected access_token in URL");
        
        try {
          // Process the auth token from the URL
          await supabase.auth.getSession();
          
          // Verify we have a session
          const { data: { session }, error } = await supabase.auth.getSession();
          
          if (error) throw error;
          
          if (session) {
            console.log("Auth token processed successfully");
            toast({
              title: "Successfully signed in",
              description: "You have been signed in successfully.",
            });
            
            // Redirect to submit-app after authentication
            navigate("/submit-app", { replace: true });
          }
        } catch (error) {
          console.error("Error processing auth token:", error);
          toast({
            title: "Authentication failed",
            description: "There was an error signing you in. Please try again.",
            variant: "destructive",
          });
          
          // Redirect to auth page to try again
          navigate("/auth", { replace: true });
        } finally {
          setIsProcessing(false);
        }
      }
    };
    
    processAuthToken();
  }, [location, navigate, toast]);
  
  // If processing, show a minimal loading state
  if (isProcessing) {
    return <div className="flex justify-center items-center min-h-screen">Processing authentication...</div>;
  }
  
  // Otherwise, render the children
  return <>{children}</>;
};

export default AuthHandler;
